import { ILongRunningProcess } from '../../interfaces/ilong-running-process';
import { Scenario } from '../scenario';

export class LongRunningProcessBase {
  LongRunningProcessId: number;
  Name: string;
  Note: string | null;
  ScenarioId: number | null;
  Started: Date;
  EstimatedCompletion: Date | null;
  ProgressPercent: number;
  CurrentStatusName: string | null;
  Completed: Date | null;
  StartedByUID: string;
  Error: string | null;
  UniqueId: string | null;
  CompletedOk: boolean;
  LastUpdated: Date;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  Scenario?: Scenario;

  constructor(item?: ILongRunningProcess) {
    if (item) {

      this.LongRunningProcessId = item.LongRunningProcessId;
      this.Name = item.Name;
      this.Note = item.Note;
      this.ScenarioId = item.ScenarioId;
      this.Started = item.Started ? new Date(item.Started) : null;
      this.EstimatedCompletion = item.EstimatedCompletion ? new Date(item.EstimatedCompletion) : null;
      this.ProgressPercent = item.ProgressPercent;
      this.CurrentStatusName = item.CurrentStatusName;
      this.Completed = item.Completed ? new Date(item.Completed) : null;
      this.StartedByUID = item.StartedByUID;
      this.Error = item.Error;
      this.UniqueId = item.UniqueId;
      this.CompletedOk = item.CompletedOk;
      this.LastUpdated = item.LastUpdated ? new Date(item.LastUpdated) : null;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.Scenario = new Scenario(item.Scenario);
    }
  }
}